<template>
  <div id="salvageApplicationStepsMainDiv">
    <v-container>
      <h1 id="applicationStepsHeading">
        {{ englishLang.salvageNonRepairableTitleFormStepsHeading }}
      </h1>
      <v-row>
        <v-col style="width: 60vw; padding-top: 0;">
          <v-card class="stepsCard" variant="outlined">
            <v-row class="ma-0" style="background-color: #1b365d;">
              <v-col cols="2" class="stepLabel">
                <h2 class="step">
                  {{ englishLang.salvageNonRepairableTitleFormSteps1Label }}
                </h2>
              </v-col>
              <v-col cols="10" class="stepInfo">
                <span>
                  {{ englishLang.salvageNonRepairableTitleFormSteps1Value }}
                  <p class="verbiage-text">
                    {{ englishLang.salvageNonRepairableTitleFormSteps1Text }}
                  </p>
                </span>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="stepsCard" variant="outlined">
            <v-row class="ma-0" style="background-color: #1b365d;">
              <v-col cols="2" class="stepLabel">
                <h2 class="step">
                  {{ englishLang.salvageNonRepairableTitleFormSteps2Label }}
                </h2>
              </v-col>
              <v-col cols="10" class="stepInfo">
                <span>
                  {{ englishLang.salvageNonRepairableTitleFormSteps2Value }}
                  <br />
                  <p class="verbiage-text">
                    {{ englishLang.salvageNonRepairableTitleFormSteps2Text }}
                  </p>
                </span>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="stepsCard" variant="outlined">
            <v-row class="ma-0" style="background-color: #1b365d;">
              <v-col cols="2" class="stepLabel">
                <h2 class="step">
                  {{ englishLang.salvageNonRepairableTitleFormSteps3Label }}
                </h2>
              </v-col>

              <v-col cols="10" class="stepInfo">
                <span>
                  {{ englishLang.salvageNonRepairableTitleFormSteps3Value }}
                  <br />
                  <p class="verbiage-text">
                    {{ englishLang.salvageNonRepairableTitleFormSteps3Text }}
                  </p>
                </span>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="stepsCard" variant="outlined">
            <v-row class="ma-0" style="background-color: #1b365d;">
              <v-col cols="2" class="stepLabel">
                <h2 class="step">
                  {{ englishLang.salvageNonRepairableTitleFormSteps4Label }}
                </h2>
              </v-col>
              <v-col cols="10" class="stepInfo">
                <span>
                  {{ englishLang.salvageNonRepairableTitleFormSteps4Value }}
                  <p class="verbiage-text">
                    {{ englishLang.salvageNonRepairableTitleFormSteps4Text }}
                  </p>
                </span>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="stepsCard" variant="outlined">
            <v-row class="ma-0" style="background-color: #1b365d;">
              <v-col cols="2" class="stepLabel">
                <h2 class="step">
                  {{ englishLang.salvageNonRepairableTitleFormSteps5Label }}
                </h2>
              </v-col>
              <v-col cols="10" class="stepInfo">
                {{ englishLang.salvageNonRepairableTitleFormSteps5Value }}
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex flex-wrap justify-center align-center ga-2">
          <v-form
            v-if="!emailValidated"
            align="center"
            class="d-flex flex-wrap justify-center align-center"
            ref="emailForm"
            lazy-validation
            @submit.prevent
          >
            <v-text-field
              :label="englishLang.salvageEmailInputLabel"
              v-model="email"
              autocomplete="off"
              style="width: 24vw"
              hide-details=""
              @keyup.enter="validateEmailInfo"
              class="ma-2"
              :rules="[rules.required, rules.email]"
              outlined
              dense
            ></v-text-field>
            <loading-button
              @click="validateEmailInfo"
              :loading="loading"
              :loading-label="englishLang.validatingEmail"
              color="secondary"
              class="ma-2"
            >
              {{ englishLang.emailSubmitButton }}
            </loading-button>
          </v-form>
          <v-btn
            v-if="emailValidated"
            @click="
              store.dispatch('setGuestInfo', {
                email,
                token: jwtToken,
                transactionType: 'Salvage'
              });
              $router.push({
                name: 'SalvageApplication',
                params: {
                  isAuthenticated: true
                }
              });
            "
            color="secondary"
            class="ma-2"
            >{{ englishLang.salvageButton }}</v-btn
          >
          <v-btn
            v-if="emailValidated"
            @click="
              store.dispatch('setGuestInfo', {
                email,
                token: jwtToken,
                transactionType: 'Non-Repairable'
              });
              $router.push({
                name: 'SalvageApplication',
                params: {
                  isAuthenticated: true
                }
              });
            "
            color="secondary"
            class="ma-2"
            >{{ englishLang.nonRepairableButton }}</v-btn
          >
          <v-btn
            v-if="!emailValidated"
            @click="
              $router.push({
                name: 'SalvageApplicationStatus'
              })
            "
            color="secondary"
            class="ma-2"
            >{{ englishLang.checkStatusButton }}</v-btn
          >
          <v-btn
            @click="$router.push({ name: 'Home' })"
            class="bg-orange text-white ma-2"
            >{{ englishLang.quitButton }}</v-btn
          >
        </v-col>
      </v-row>
      <accessible-bottom-sheet
        v-if="addAccessCodeDialog"
        v-model="addAccessCodeDialog"
        persistent
        aria-label="Provide the access code"
      >
        <v-sheet class="text-center" height="245px">
          <v-card>
            <v-card-title>
              {{ englishLang.accessCodeSheetTitle }}
              <v-divider />
              <v-btn icon @click="handleSheetClose" aria-label="Close">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-flex class="d-flex align-center">
              <v-col offset-lg="4" lg="4">
                <v-container>
                  <v-form ref="accessCodeForm" lazy-validation @submit.prevent>
                    <label class="d-flex mb-2" for="accessCodeInput">{{
                      englishLang.accessCodeInputLabel
                    }}</label>
                    <v-text-field
                      id="accessCodeInput"
                      autocomplete="off"
                      outlined
                      dense
                      @keyup.enter="validateAccessCode"
                      :error-messages="accessCodeErrorMessage"
                      v-model="accessCode"
                      :rules="[rules.required]"
                    ></v-text-field>
                    <v-row>
                      <v-col>
                        <loading-button
                          block
                          depressed
                          color="secondary"
                          :loading="loading"
                          :loading-label="englishLang.validatingAccessCode"
                          @click="validateAccessCode"
                        >
                          {{ englishLang.accessCodeSubmitButton }}
                        </loading-button>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-col>
            </v-flex>
          </v-card>
        </v-sheet>
      </accessible-bottom-sheet>
    </v-container>
  </div>
</template>

<script>
import EnglishLang from "../../public/languages/English.json";
import RequestHandler from "@/assets/ts/requestHandler.ts";
import store from "@/store";
import { mapGetters } from "vuex";
import AccessibleBottomSheet from "@/components/AccessibleBottomSheet.vue";
import LoadingButton from "@/components/LoadingButton.vue";
export default {
  name: "Salvage",
  components: { AccessibleBottomSheet, LoadingButton },
  data: function() {
    return {
      englishLang: EnglishLang,
      email: undefined,
      store: store,
      emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      rules: {
        required: value => !!value || this.englishLang.requiredErrorMessage,
        email: value => {
          return (
            this.emailRegex.test(value) ||
            this.englishLang.invalidEmailAddressErrorMessage
          );
        }
      },
      emailValidated: false,
      addAccessCodeDialog: false,
      RH: new RequestHandler(),
      accessCode: undefined,
      loading: false,
      accessCodeErrorMessage: "",
      jwtToken: null
    };
  },
  computed: {
    ...mapGetters(["showAlert", "alertParams"]),
    emailForm: function() {
      return this.$refs.emailForm;
    },
    accessCodeForm: function() {
      return this.$refs.accessCodeForm;
    }
  },
  methods: {
    async validateEmailInfo() {
      if (this.emailForm.validate()) {
        try {
          this.loading = true;
          await this.RH.getTennesseeMVDSAccessCode({
            emailAddress: this.email
          });
          this.addAccessCodeDialog = true;
        } catch (error) {
          this.store.dispatch("setGlobalAlertState", {
            title: this.englishLang.emailAlertTitle,
            description: this.englishLang.emailAlertDescription,
            variant: "error"
          });
          this.email = undefined;
        } finally {
          this.loading = false;
        }
      }
    },
    async validateAccessCode() {
      if (this.accessCodeForm.validate()) {
        try {
          this.loading = true;
          this.jwtToken = await this.RH.getGuestJWT({
            emailAddress: this.email,
            passcode: this.accessCode
          });
          this.addAccessCodeDialog = false;
          this.emailValidated = true;
          this.accessCodeErrorMessage = "";
        } catch (error) {
          this.accessCodeErrorMessage = this.englishLang.invalidAccessCodeErrorMessage;
        } finally {
          this.loading = false;
        }
      }
    },
    handleSheetClose() {
      this.accessCode = undefined;
      this.addAccessCodeDialog = false;
      this.email = undefined;
    }
  }
};
</script>

<style scoped lang="scss">
.stepLabel {
  display: flex;
  justify-content: center;
  align-items: center;
}
.step {
  color: white;
  margin: 0;
}

.stepsCard {
  display: flex;
  flex-direction: column;
  margin: 8px !important;
  border: 1px solid #1b365d;
}

.stepInfo {
  display: flex;
  justify-content: flex-start;
  padding: 12px 8px !important;
  font-weight: 500 !important;
  align-items: center;
  background-color: white;
  border-radius: 0.25rem;
}
.no-wrap {
  white-space: nowrap;
}
.verbiage-text {
  font-family: sans-serif;
  font-size: small;
  margin: 0;
}

@media (min-width: 1264px) {
  #salvageApplicationStepsMainDiv {
    margin-top: -100px;
  }
}
</style>
